import type { FC } from 'react';

import classNames from 'classnames';

import { getOS } from '@iconik-io/core/src/os/get_os';

import isTouchDevice from '../../utils/is_touch_device';

import styles from './send_hint.module.css';

type Props = {
  className?: string;
};

const SendHint: FC<Props> = ({ className }) => {
  if (isTouchDevice()) {
    return null;
  }

  return (
    <div className={classNames(styles.root, className)}>
      {getOS() === 'MacOS' ? (
        <>
          {' ⌘'}
          <span className={styles.return_char}>⮐ </span>
        </>
      ) : (
        <>
          {' Ctrl+'}
          <span className={styles.return_char}>⮐ </span>
        </>
      )}
    </div>
  );
};

export default SendHint;
